"use client";

import { Button } from "@/components/ui/button";

export default function ConnectQuoteButton() {
  return (
    <Button
      size="lg"
      variant="outline"
      onClick={() => window.dispatchEvent(new CustomEvent("open-cart"))}
    >
      Download your instant Quote
    </Button>
  );
}